import { coverReferrerPolicy, coverImageUrl } from "@/yomiri/ui/components/coverReferrerPolicy.ts";
import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import AutoStories from '@mui/icons-material/AutoStoriesOutlined';

export function YomiriCover({
  src,
  blob,
  width = 60,
  seen = false,
  progress,
}: {
  src?: string;
  blob?: Blob;
  width?: number | string;
  seen?: boolean;
  progress?: number;
}) {
  const [local, setLocal] = useState<string>();
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    if (!blob) {
      setLocal(undefined);
      return;
    }
    const url = URL.createObjectURL(blob);
    setLocal(url);
    return () => URL.revokeObjectURL(url);
  }, [blob]);
  useEffect(() => setFailed(false), [src, local]);

  const clampedProgress = typeof progress === 'number' && !Number.isNaN(progress)
    ? Math.max(0, Math.min(100, Math.round(progress)))
    : null;

  return (
    <Box
      sx={{
        width,
        aspectRatio: '2/3',
        flexShrink: 0,
        borderRadius: '6px',
        overflow: 'hidden',
        position: 'relative',
        bgcolor: 'var(--y-containerHigh)',
        display: 'grid',
        placeItems: 'center',
        filter: seen ? 'grayscale(1)' : undefined,
        opacity: seen ? 0.5 : 1,
      }}
    >
      {(local || src) && !failed ? (
        <Box
          component="img"
          src={coverImageUrl(local || src)}
          referrerPolicy={coverReferrerPolicy(local || src)}
          alt=""
          loading="lazy"
          decoding="async"
          onError={() => setFailed(true)}
          sx={{ display: 'block', width: '100%', height: '100%', objectFit: 'cover' }}
        />
      ) : (
        <AutoStories sx={{ color: 'var(--y-onSurfaceVariant)' }} />
      )}

      {clampedProgress !== null && clampedProgress > 0 && (
        <Box
          sx={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: 4,
            bgcolor: 'rgba(0,0,0,0.5)',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              width: `${clampedProgress}%`,
              height: '100%',
              bgcolor: 'var(--y-primary, #ff375f)',
              borderRadius: '0 2px 2px 0',
            }}
          />
        </Box>
      )}
    </Box>
  );
}
